import { render, staticRenderFns } from "./DaccountForm.vue?vue&type=template&id=7a59e278&"
import script from "./DaccountForm.vue?vue&type=script&lang=js&"
export * from "./DaccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports